import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isVisible: false,
  message: "",
  data: null,
  actionType: null,
  // Optional: how the popup looks when the action name doesn't say it —
  // "ban" / "unban" for toggles (see KINDS in ConfirmationModal).
  confirmKind: null,
};

const confirmationModalSlice = createSlice({
  name: "confirmationModal",
  initialState,
  reducers: {
    showConfirmationModal: (state, action) => {
      state.isVisible = true;
      state.message = action.payload.message;
      state.data = action.payload.data;
      state.actionType = action.payload.actionType;
      state.confirmKind = action.payload.confirmKind ?? null;
    },
    hideConfirmationModal: (state, action) => {
      state.isVisible = false;
      state.message = "";
      state.data = null;
      state.actionType = null;
      state.confirmKind = null;
    },
  },
});

export const { showConfirmationModal, hideConfirmationModal } =
  confirmationModalSlice.actions;

export default confirmationModalSlice.reducer;
